var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrontEnd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110 87.7318C110 92.1342 106.398 95.7361 101.996 95.7361H8.00426C3.60192 95.7361 0 92.1342 0 87.7318V22.2682C0 17.8658 3.60192 14.2639 8.00426 14.2639H101.996C106.398 14.2639 110 17.8658 110 22.2682V87.7318Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.996 14.2639H8.00426C3.60192 14.2639 0 17.8658 0 22.2682V26.0526H110V22.2682C110 17.8658 106.398 14.2639 101.996 14.2639Z",
    fill: "url(#paint0_linear_10_59)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2829 22.8019C11.743 22.8019 12.9266 21.6183 12.9266 20.1583C12.9266 18.6982 11.743 17.5146 10.2829 17.5146C8.82288 17.5146 7.63928 18.6982 7.63928 20.1583C7.63928 21.6183 8.82288 22.8019 10.2829 22.8019Z",
    fill: "#FB7598"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0193 22.8019C21.4794 22.8019 22.663 21.6183 22.663 20.1583C22.663 18.6982 21.4794 17.5146 20.0193 17.5146C18.5593 17.5146 17.3757 18.6982 17.3757 20.1583C17.3757 21.6183 18.5593 22.8019 20.0193 22.8019Z",
    fill: "#FEE050"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7557 22.8019C31.2158 22.8019 32.3994 21.6183 32.3994 20.1583C32.3994 18.6982 31.2158 17.5146 29.7557 17.5146C28.2957 17.5146 27.1121 18.6982 27.1121 20.1583C27.1121 21.6183 28.2957 22.8019 29.7557 22.8019Z",
    fill: "#61B4E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7022 36.8321H14.2793V62.7768H41.7022V36.8321Z",
    fill: "url(#paint1_linear_10_59)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1478 36.8321H51.4104V47.6407H96.1478V36.8321Z",
    fill: "url(#paint2_linear_10_59)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1478 51.9678H51.4104V62.7768H96.1478V51.9678Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4104 68.6583H14.2793V81.8695H51.4104V68.6583Z",
    fill: "url(#paint3_linear_10_59)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1478 68.6583H80.9352V81.8695H96.1478V68.6583Z",
    fill: "url(#paint4_linear_10_59)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7791 68.6583H58.5662V81.8695H73.7791V68.6583Z",
    fill: "url(#paint5_linear_10_59)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2947 56.1032L78.9118 53.8351L63.5926 49.5336L67.8941 64.8528L70.1628 59.2354L76.1385 65.211L79.2701 62.0788L73.2947 56.1032Z",
    fill: "#1E252B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_59",
    x1: 4.80256,
    y1: 25.9338,
    x2: 105.976,
    y2: 25.9338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333E48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333E48",
    stopOpacity: 0.76
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10_59",
    x1: 5.76308,
    y1: 40.8217,
    x2: 29.6958,
    y2: 60.7267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6CA5",
    stopOpacity: 0.96
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10_59",
    x1: 56.35,
    y1: 42.2625,
    x2: 92.5292,
    y2: 47.7054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0635706,
    stopColor: "#005CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CB9",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10_59",
    x1: 18.379,
    y1: 75.2958,
    x2: 48.7696,
    y2: 78.4004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0635706,
    stopColor: "#005CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CB9",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10_59",
    x1: 82.6149,
    y1: 75.2958,
    x2: 95.1738,
    y2: 75.8214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0635706,
    stopColor: "#005CB9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CB9",
    stopOpacity: 0.69
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10_59",
    x1: 52.0277,
    y1: 68.5165,
    x2: 66.1727,
    y2: 81.8695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A6CA5",
    stopOpacity: 0.96
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontEnd);
export default __webpack_public_path__ + "static/media/FrontEnd.b8f44ee84d0ee09b94bd6a33a07c9739.svg";
export { ForwardRef as ReactComponent };